import "./HomePage.css"
export const Homepage = () => {
  return (
    <div style={{width:"100%"}}>
      <img style={{width:"90%"}}
        className="i1"
        src="https://www.bathandbodyworks.in/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dwe2154231/1SElectitems.jpg"
      ></img>
      <div className="b">
        <h1 id="h1">TODAY'S TOP OFFERS</h1>
        <div className="bs">
          <div className="box">
            <p className="p1">Limited Time only!</p>
            <p>Online Only!</p>
            <div>Spring Gift Bundle</div>
            <h3>$40 with any $40 purchase</h3>
            <button className="b1">Shop</button>
          </div>
          <div className="box">
            <p className="p1">Limited Time only!</p>
            <p>Online Only!</p>
            <div>Spring Gift Bundle</div>
            <h3>$40 with any $40 purchase</h3>
            <button className="b1">Shop</button>
          </div>
          <div className="box">
            <p>Limited Time only!</p>
            <p>Online Only!</p>
            <div>Spring Gift Bundle</div>
            <h3>$40 with any $40 purchase</h3>
            <button className="b1">Shop</button>
          </div>
          <div className="box">
            <p>Limited Time only!</p>
            <p>Online Only!</p>
            <div>Spring Gift Bundle</div>
            <h3>$40 with any $40 purchase</h3>
            <button className="b1">Shop</button>
          </div>
        </div>
      </div>
      <div id="d1">Limited time only! Online only!</div>
      <h2 id="h2">Spring gift bundle</h2>
      <div>Give a little (or a lot) to allllll the moms...</div>
      <button id="b2">SHOP</button>

      <div id="d3">
        <img
          id="i2"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw0f646ce5/images/Spring2022/oo-pwp-sp3-atb-lto.jpg?yocs=o_s_"
        ></img>
        <div>
          {" "}
          <img
            id="i3"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw57c95821/hires/025144398_alt_1.jpg?sh=413&yocs=o_s_"
          ></img>
          <h2 id="h3">New!</h2>
          <h3 id="h4">Limited Edition</h3>
          <div id="h5">Spring Gift Bundle</div>
          <h4 id="h6">$112.00</h4>
          <button id="h7">Add To Bag</button>
        </div>
      </div>
      <div>
        <img
          id="i4"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw377d7fac/images/Spring2022/diff_mday_sp3_hm.jpg?yocs=s_"
        ></img>
      </div>
      <h2>SHOP BY CATEGORY</h2>
      <div id="i5">
        <div>
          <img
            className="i51"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw8d1d6d80/images/Spring2022/fbc_butterfly_sp3_vn.jpg?yocs=o_s_"
          ></img>
          <p>Shop Body Care</p>
        </div>
        <div>
          <img
            className="i51"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dwffda5c2c/images/Spring2022/cndl_mday-all_sp3_vn.jpg?yocs=o_s_"
          ></img>
          <p>Shop Candles</p>
        </div>
        <div>
          <img
            className="i51"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dwa9dab2b4/images/Spring2022/diff_mday_sp3_vn.jpg?yocs=o_s_"
          ></img>
          <p>Shop Wallflowers</p>
        </div>
        <div>
          <img
            className="i51"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dwdfb0c185/images/Spring2022/sp_garden-infusion_sp3_vn.jpg?yocs=o_s_"
          ></img>
          <p>Shop Hand Soaps</p>
        </div>
        <div>
          <img
            className="i51"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw556bcddf/images/Spring2022/obc_atviznav_0_sp1_vn.jpg?yocs=o_s_"
          ></img>
          <p>Shop Aromatherapy</p>
        </div>
        <div>
          <img
            className="i51"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw0ce7d5cc/images/Spring2022/g_gift-sets_sp3_vn.jpg?yocs=o_s_"
          ></img>
          <p>Shop Gift Sets</p>
        </div>
      </div>
      <div id="i6">
        <div>
          <img
            className="i61"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw873afeed/images/Spring2022/cndl_mday-all_sp3_hps.jpg?yocs=o_s_"
          ></img>
          <p>Shop Candles</p>
        </div>
        <div>
          <img
            className="i61"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw0b59e716/images/Spring2022/sp_garden-infusion_sp3_hps.jpg?yocs=o_s_"
          ></img>
          <p>Shop Hand Soaps</p>
        </div>
      </div>

      <div id="i7">
        <div>
          <img
            className="i71"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw94c61375/images/Spring2022/xcat_mens-shop-hhih_sp3_hps.jpg?yocs=o_s_"
          ></img>
          <p>Shop Men's</p>
        </div>
        <div>
          <img
            className="i72"
            src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw0b59e716/images/Spring2022/sp_garden-infusion_sp3_hps.jpg?yocs=o_s_"
          ></img>
          <p>Shop the Collection</p>
        </div>
      </div>
      <img
        id="i8"
        src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw2106374d/images/Spring2022/xcat_give-love-mday_sp3_hb.jpg?yocs=s_"
      ></img>
      <div id="d4">
        <button className="b3">TOP GIFTS</button>
        <button className="b3">GIFTS SETS</button>
        <button className="b3">GIFTS FOR HER</button>
        <button className="b3">GIFTS UNDER & 15</button>
        <button className="b3">GIFTS UNDER & 30</button>
      </div>
      <button id="b4">GIFTS FOR EVERYONE</button>
      <h1 id="h8">MORE GOOD THINGS, THIS WAY</h1>
      <div id="d5">
        <img
          className="i81"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw8f6e14ad/images/Spring2022/xcat_mwts-bopis_sp2_vn.jpg?yocs=o_s_"
        ></img>
        <img
          className="i81"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw644e724c/images/Spring2022/xcat_mwts-sms_sp2_vn.jpg?yocs=o_s_"
        ></img>
        <img
          className="i81"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw41a3328c/images/Spring2022/xcat_mwts-email_sp2_vn.jpg?yocs=o_s_"
        ></img>
        <img
          className="i81"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw611329aa/images/Spring2022/xcat_mwts-autorefresh_sp2_vn.png?yocs=o_s_"
        ></img>
        <img
          className="i81"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw7500932b/images/Spring2022/xcat_mwts-dei_sp2_vn.jpg?yocs=o_s_"
        ></img>
        <img
          className="i81"
          src="https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/on/demandware.static/-/Sites-BathAndBodyWorks-Library/default/dw4dd3c5f1/images/Spring2022/xcat_mwts-returns_sp2_vn.jpg?yocs=o_s_"
        ></img>
      </div>
      <img
        id="i91"
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvLU3xEAshWHwRa-915wwMTzCRPRoeLnMZenx5EVzCK579O8DUhqhdW1EvlW7o9-Q7_lI&usqp=CAU"
      ></img>
      <h2>@ B A T H A N D B O D Y W O R K S</h2>

      <p id="p3">Daily inspiration. Instant happiness. Right here.</p>
      <div id="i6">
        <img
          className="i11"
          src="https://images.dashhudson.com/aHR0cHM6Ly9jZG4uZGFzaGh1ZHNvbi5jb20vbWVkaWEvZnVsbC8xNjUxNjA0NDM5LjU2ODkzNTM0NTg1LmpwZWc=.jpg?w=640&h=640&fit=cover"
        ></img>
        <img
          className="i11"
          src="https://images.dashhudson.com/aHR0cHM6Ly9jZG4uZGFzaGh1ZHNvbi5jb20vbWVkaWEvZnVsbC8xNjUxNTg5MTQ2LjExNzEzNzI5NzYuanBlZw==.jpg?w=640&h=640&fit=cover"
        ></img>
        <img
          className="i11"
          src="https://images.dashhudson.com/aHR0cHM6Ly9jZG4uZGFzaGh1ZHNvbi5jb20vbWVkaWEvZnVsbC8xNjUxNTE4MDg0LjQ1NzcyNjUzNTE2My5qcGVn.jpg?w=640&h=640&fit=cover"
        ></img>
        <img
          className="i11"
          src="https://images.dashhudson.com/aHR0cHM6Ly9jZG4uZGFzaGh1ZHNvbi5jb20vbWVkaWEvZnVsbC8xNjUxNTAwMDc5LjUxNjA4MjM5NDU1Ny5qcGVn.jpg?w=640&h=640&fit=cover"
        ></img>
      </div>
      <h1 id="h11">Bath & Body Works</h1>
      <p id="p4">
        Bath and Body Works is your go-to place for gifts & goodies that
        surprise & delight. From fresh fragrances to soothing skin care, we make
        finding your perfect something special a happy-memory-making experience.
        Searching for new seasonal creations or your favorite discontinued
        scents? We’ve got you covered there, too. Oh! And while you're browsing,
        shop our latest & greatest selection of lotions, soaps and candles!
      </p>
    </div>
  );
};
